<template>
  <div>
    {{this.promotions}}
  </div>

</template>

<script>
import axios from 'axios';
import { promotionsCollection } from '../firebase-config.js'

export default {
  data: function () {
    return {
      promotions: []
    }
  },
  methods: {
  },
  created () {
    promotionsCollection.onSnapshot((promotionsRef) => {
      promotionsCollection.get().then((querySnapshot) => {
        this.loading = false
        querySnapshot.forEach((doc) => {

          let data = {
            'promotionId': doc.data().promotionId,
            'models': doc.data().models,
            'codes': doc.data().codes,
            'active': doc.data().active
          }
          this.promotions.push(data)
        })
        axios.post('publish/publish-live.php', this.promotions)
          .then(data => {
            console.log('publish live');
          })
          .catch(error => {
            console.log(error)
          });
      })
   })
  }
}
</script>


// WEBPACK FOOTER //
// Data.vue?7eb7cd0e